import BlueDesign from './tech/BlueDesign';
import GreenDesign from './tech/GreenDesign';
import OrangeDesign from './tech/OrangeDesign';
import ColorfulDesign from './tech/ColorfulDesign';
import GradientDesign from './tech/GradientDesign';
import DefaultBlackDesign from './default/DefaultBlackDesign';
import DefaultGrayDesign from './default/DefaultGrayDesign';
import NavyProfessionalDesign from './professional/NavyProfessionalDesign';
import CharcoalProfessionalDesign from './professional/CharcoalProfessionalDesign';
import BeigeProfessionalDesign from './professional/BeigeProfessionalDesign';
import OliveProfessionalDesign from './professional/OliveProfessionalDesign';
import TealProfessionalDesign from './professional/TealProfessionalDesign';
import BurgundyProfessionalDesign from './professional/BurgundyProfessionalDesign';
import VibrantYellowDesign from './tech/VibrantYellowDesign';

// Registry for all designs
export const DESIGNS = {
  'default-black': DefaultBlackDesign,
  'default-gray': DefaultGrayDesign,
  'blue': BlueDesign,
  'green': GreenDesign,
  'orange': OrangeDesign,
  'colorful': ColorfulDesign,
  'gradient': GradientDesign,
  'vibrant-yellow': VibrantYellowDesign,
  'navy-professional': NavyProfessionalDesign,
  'charcoal-professional': CharcoalProfessionalDesign,
  'beige-professional': BeigeProfessionalDesign,
  'olive-professional': OliveProfessionalDesign,
  'teal-professional': TealProfessionalDesign,
  'burgundy-professional': BurgundyProfessionalDesign,
};

// Get all designs as an array
export const getAllDesigns = () => {
  return Object.values(DESIGNS);
};

// Get a specific design by ID
export const getDesignById = (id) => {
  return DESIGNS[id] || DESIGNS['default-black']; // Fallback to default black design
};

// Helper function to get translated design names
export const getTranslatedDesignName = (designId, t) => {
  const design = getDesignById(designId);
  if (!design || !t) return designId;
  return t(`designNames.${design.name}`) || design.name;
};

// Helper function to get translated design category
export const getTranslatedDesignCategory = (category, t) => {
  return t(`designNames.${category}`) || category;
};

export default {
  getAllDesigns,
  getDesignById,
  DESIGNS,
  getTranslatedDesignName,
  getTranslatedDesignCategory
}; 